export default "__VITE_ASSET__BIXbL3JK__"